// extracted by mini-css-extract-plugin
export default {"listImageBackgroundColor":"_24xvc","square":"_1Y-6i"};